"use client";

import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";
import * as React from "react";
import { cn } from "../lib/utils";

const RadioCardGroup = React.forwardRef<
  React.ComponentRef<typeof RadioGroupPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root>
>(({ className, ...props }, ref) => {
  return (
    <RadioGroupPrimitive.Root
      className={cn("flex flex-col gap-4", className)}
      {...props}
      ref={ref}
    />
  );
});
RadioCardGroup.displayName = RadioGroupPrimitive.Root.displayName;

const RadioCardGroupItem = React.forwardRef<
  React.ComponentRef<typeof RadioGroupPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item>
>(({ className, children, ...props }, ref) => {
  return (
    <RadioGroupPrimitive.Item
      ref={ref}
      className={cn(
        "min-h-[5.875rem] w-full rounded-lg sm:w-[28.375rem]",
        "px-4 py-3",
        "bg-white",
        "flex items-start gap-3",
        "cursor-pointer",
        "focus-visible:ring-brand-primary-regular focus-visible:outline-none focus-visible:ring-2",
        className,
      )}
      {...props}
    >
      <div className="flex items-center gap-3">
        <div
          className={cn(
            "border-brand-primary-regular text-brand-primary-regular group aspect-square h-4 w-4 rounded-full border",
            "focus-visible:ring-brand-primary-regular focus:outline-none focus-visible:ring-2",
            "relative",
          )}
        >
          <RadioGroupPrimitive.Indicator className="absolute inset-0 flex items-center justify-center">
            <div className="h-2.5 w-2.5 rounded-full bg-current" />
          </RadioGroupPrimitive.Indicator>
        </div>
        <div className="text-left">{children}</div>
      </div>
    </RadioGroupPrimitive.Item>
  );
});
RadioCardGroupItem.displayName = RadioGroupPrimitive.Item.displayName;

export { RadioCardGroup, RadioCardGroupItem };
